export enum Role {
  AIRPORT_OPERATOR = 'airport_operator',
  OPS_SUPERVISOR = 'ops_supervisor',
  FINANCE_AUDIT = 'finance_audit',
  ADMIN = 'admin',
}

export const RoleHierarchy: Record<Role, readonly Role[]> = {
  [Role.ADMIN]: [Role.OPS_SUPERVISOR, Role.AIRPORT_OPERATOR, Role.FINANCE_AUDIT],
  [Role.OPS_SUPERVISOR]: [Role.AIRPORT_OPERATOR],
  [Role.AIRPORT_OPERATOR]: [],
  [Role.FINANCE_AUDIT]: [],
};

export function hasRole(userRole: Role, requiredRole: Role): boolean {
  if (userRole === requiredRole) return true;
  return RoleHierarchy[userRole].includes(requiredRole);
}

export function hasAnyRole(userRole: Role, requiredRoles: readonly Role[]): boolean {
  return requiredRoles.some((required) => hasRole(userRole, required));
}

const VALID_ROLES = new Set<string>(Object.values(Role));

export function isRole(value: unknown): value is Role {
  return typeof value === 'string' && VALID_ROLES.has(value);
}
